var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes201X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Cloud/20/my.drafts@1x",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.025 0h5.95c1.225 0 1.67.128 2.118.367.448.24.8.592 1.04 1.04.24.448.367.893.367 2.118v5.95c0 1.225-.128 1.67-.367 2.118-.24.448-.592.8-1.04 1.04-.448.24-.893.367-2.118.367h-5.95c-1.225 0-1.67-.128-2.118-.367-.448-.24-.8-.592-1.04-1.04C.627 11.145.5 10.7.5 9.475v-5.95c0-1.225.128-1.67.367-2.118.24-.448.592-.8 1.04-1.04C2.355.127 2.8 0 4.025 0z",
    id: "Rectangle",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fill: "currentColor",
    d: "M0 3.5h14v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v2.5h9.5v1H4v2h9.5v1H4V13H3v-2.5H.5v-1H3v-2H.5v-1H3V4h1z",
    id: "Combined-Shape",
    fill: "currentColor",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0h7a3 3 0 013 3v1H.5V3a3 3 0 013-3z",
    id: "Rectangle",
    fill: "currentColor",
    opacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes201X);
export default __webpack_public_path__ + "static/media/notes-20-1x.841e05dc.svg";
export { ForwardRef as ReactComponent };